import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/pages/home/Home';
import Presentation from './components/pages/presentation/Presentation';
import NavBar from './components/navbar/Navbar';
import Footer from './components/footer';
import Office from './components/pages/office/Office';
import Services from './components/pages/services/Services';
import Blog from './components/pages/blog/Blog';
import Contact from './components/pages/contact/Contact';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/*"
          element={
            <>
              <div className="flex flex-1 flex-col-reverse">
                <Footer />
                <Routes>
                  <Route path="acasa" element={<Home />} />
                  <Route path="prezentare" element={<Presentation />} />
                  <Route path="cabinet" element={<Office />} />
                  <Route path="servicii" element={<Services />} />
                  <Route path="blog" element={<Blog />} />
                  <Route path="contact" element={<Contact />} />
                  <Route path="*" element={<Navigate to="acasa" />} />
                </Routes>
                <NavBar />
              </div>
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
